// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkerModal_modal__zqO\\+H {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  display: flex;
  align-items: center;
}

.WorkerModal_content__ySTs2 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.WorkerModal_main__aFm2G {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.WorkerModal_footer__AnfI- {
  justify-content: flex-end;
  gap: 20px;
}

.WorkerModal_left__W1t2X {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 500px;
  height: 750px;
  border-radius: 5px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.WorkerModal_cardMain__o4Iaj {
  display: flex;
  flex-direction: column;
  height: 600px;
}
.WorkerModal_cardMain__o4Iaj h2 {
  font-size: 50px;
}
.WorkerModal_workerImg__DRIbX {
  width: 200px;
  height: 250px;
  margin-left: auto;
  margin-right: auto;
  object-fit: cover;
}

.WorkerModal_cardFooter__VwZ4v {
  display: flex;
  gap: 20px;
  background-color: #099268;
  height: 150px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 0 30px;
  display: flex;
  align-items: center;
}
.WorkerModal_cardFooter__date__xgtXs {
  color: white;
  margin-left: auto;
  margin-right: auto;
  font-size: 30px;
}
.WorkerModal_cardFooter__left__gXeCf {
  width: 100px;
  height: 100px;
}
.WorkerModal_cardFooter__left__gXeCf .WorkerModal_qr__g5hop {
  width: 100px;
  height: 100px;
}

.WorkerModal_mainJob__EDsqK {
  font-size: 45px;
  color: white;
}

.WorkerModal_cardFooterCode__Y\\+gcd {
  font-size: 30px;
  color: white;
}

.WorkerModal_studiing__8DA\\+j {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
}
.WorkerModal_studiing__block__AgOqj {
  display: flex;
  align-items: center;
  gap: 20px;
  text-align: center;
}
.WorkerModal_studiing__block__AgOqj h3 {
  display: flex;
  font-size: 35px;
  width: 80%;
  line-height: 100%;
  text-align: start;
}
.WorkerModal_studiing__block__AgOqj span {
  font-size: 25px;
}
.WorkerModal_studiing__8DA\\+j .WorkerModal_fontLarge__uZOMS {
  font-size: 35px;
}
.WorkerModal_studiing__8DA\\+j .WorkerModal_fontSmall__sFnUm {
  font-size: 25px;
}

@media print {
  #WorkerModal_sizer__PQ5We {
    width: 100%;
    height: auto;
  }
  @page {
    size: 21cm 14.7cm;
    margin: 0;
  }
  html,
  body {
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
  }
  body * {
    visibility: hidden;
  }
  .WorkerModal_modal__zqO\\+H,
  .WorkerModal_modal__zqO\\+H * {
    visibility: visible;
  }
  .WorkerModal_modal__zqO\\+H {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    background: white !important;
    box-shadow: none !important;
    backdrop-filter: none !important;
    z-index: auto !important;
    display: flex;
    align-items: center;
    overflow: hidden !important;
  }
  .WorkerModal_content__ySTs2 {
    height: auto !important;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden !important;
  }
  .WorkerModal_main__aFm2G {
    overflow: hidden !important;
  }
  .WorkerModal_left__W1t2X {
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 5px;
    text-align: center;
    width: 10.5cm !important;
    height: 14.7cm !important;
  }
  .WorkerModal_cardMain__o4Iaj {
    display: flex;
    flex-direction: column;
    height: 600px;
  }
  .WorkerModal_cardMain__o4Iaj h2 {
    font-size: 40px;
  }
  .WorkerModal_cardMain__right__Y77YY {
    font-size: 35px;
  }
  .WorkerModal_workerImg__DRIbX {
    width: 100px;
    height: 150px;
    margin-left: auto;
    margin-right: auto;
  }
  .WorkerModal_cardFooter__VwZ4v {
    display: flex;
    gap: 20px;
    background-color: #099268;
    height: 150px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  .WorkerModal_cardFooter__left__gXeCf {
    display: block;
    width: 50px;
    height: 50px;
    border: 1px solid white;
  }
  .WorkerModal_mainJob__EDsqK {
    font-size: 40px;
    color: white;
  }
  .WorkerModal_cardFooterCode__Y\\+gcd {
    font-size: 20px;
    color: white;
  }
  .WorkerModal_studiing__8DA\\+j {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
  }
  .WorkerModal_studiing__block__AgOqj {
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: flex-start;
  }
  .WorkerModal_studiing__block__AgOqj h3 {
    display: flex;
    justify-content: flex-start;
    width: 80%;
    text-align: start;
  }
  .WorkerModal_fontLarge__uZOMS {
    font-size: 25px !important;
  }
  .WorkerModal_fontSmall__sFnUm {
    font-size: 15px !important;
  }
  .WorkerModal_qr__g5hop {
    width: 50px !important;
    height: 50px !important;
  }
  .WorkerModal_closeButton__cVvmy {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/workers/WorkerModal.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,0BAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;AADJ;;AAIA;EAEI,WAAA;EAEA,YAAA;EACA,sBAAA;EAEA,uCAAA;EACA,aAAA;EACA,sBAAA;AAJJ;;AAQA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AALJ;;AAQA;EACI,yBAAA;EACA,SAAA;AALJ;;AAQA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;AALJ;;AAWA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AARJ;AAYI;EACI,eAAA;AAVR;AAmBA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;AAlBJ;AAoBI;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAlBR;AAqBI;EACI,YAAA;EACA,aAAA;AAnBR;AAsBQ;EACI,YAAA;EACA,aAAA;AApBZ;;AAyBA;EACI,eAAA;EACA,YAAA;AAtBJ;;AAyBA;EACI,eAAA;EACA,YAAA;AAtBJ;;AAyBA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAtBJ;AAyBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;AAxBR;AA0BQ;EACI,aAAA;EAIA,eAAA;EACA,UAAA;EACA,iBAAA;EAEA,iBAAA;AA5BZ;AAgCQ;EAEI,eAAA;AA/BZ;AAmCI;EACI,eAAA;AAjCR;AAoCI;EACI,eAAA;AAlCR;;AA2CA;EACI;IACI,WAAA;IACA,YAAA;EAxCN;EA2CE;IACI,iBAAA;IAEA,SAAA;EA1CN;EA8CE;;IAEI,sBAAA;IACA,uBAAA;IACA,4BAAA;EA5CN;EAkDE;IACI,kBAAA;EAhDN;EAoDE;;IAEI,mBAAA;EAlDN;EAsDE;IACI,6BAAA;IAGA,MAAA;IACA,OAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,4BAAA;IACA,2BAAA;IACA,gCAAA;IACA,wBAAA;IAEA,aAAA;IACA,mBAAA;IACA,2BAAA;EAvDN;EA0DE;IACI,uBAAA;IAEA,aAAA;IACA,mBAAA;IACA,uBAAA;IAGA,2BAAA;EA3DN;EA+DE;IACI,2BAAA;EA7DN;EAgEE;IACI,aAAA;IACA,sBAAA;IACA,SAAA;IAIA,kBAAA;IACA,kBAAA;IAEA,wBAAA;IACA,yBAAA;EAlEN;EAuEE;IACI,aAAA;IACA,sBAAA;IACA,aAAA;EArEN;EAyEM;IACI,eAAA;EAvEV;EA2EM;IAEI,eAAA;EA1EV;EA8EE;IACI,YAAA;IACA,aAAA;IACA,iBAAA;IACA,kBAAA;EA5EN;EA+EE;IACI,aAAA;IACA,SAAA;IACA,yBAAA;IACA,aAAA;IACA,8BAAA;IACA,+BAAA;IACA,eAAA;IAEA,aAAA;IACA,mBAAA;EA9EN;EAgFM;IACI,cAAA;IACA,WAAA;IACA,YAAA;IACA,uBAAA;EA9EV;EAkFE;IACI,eAAA;IACA,YAAA;EAhFN;EAmFE;IACI,eAAA;IACA,YAAA;EAjFN;EAoFE;IACI,aAAA;IACA,sBAAA;IACA,iBAAA;IACA,kBAAA;EAlFN;EAqFM;IACI,aAAA;IACA,mBAAA;IACA,SAAA;IAEA,2BAAA;EApFV;EAsFU;IACI,aAAA;IACA,2BAAA;IAIA,UAAA;IAEA,iBAAA;EAxFd;EAmGE;IACI,0BAAA;EAjGN;EAoGE;IACI,0BAAA;EAlGN;EAqGE;IACI,sBAAA;IACA,uBAAA;EAnGN;EAsGE;IACI,aAAA;EApGN;AACF","sourcesContent":[".modal {\n    position: fixed;\n    inset: 0;\n    backdrop-filter: blur(6px);\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 1050;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n\n\n    display: flex;\n    align-items: center;\n}\n\n.content {\n\n    width: 100%;\n\n    height: 100%;\n    background-color: #fff;\n\n    box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);\n    display: flex;\n    flex-direction: column;\n\n}\n\n.main {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.footer {\n    justify-content: flex-end;\n    gap: 20px;\n}\n\n.left {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 500px;\n    height: 750px;\n    border-radius: 5px;\n    text-align: center;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n\n}\n\n\n\n.cardMain {\n    display: flex;\n    flex-direction: column;\n    height: 600px;\n\n\n\n    h2 {\n        font-size: 50px;\n    }\n\n    &__right {\n        // font-size: clamp(30px, 5vw, 40px);\n        // font-size: 35px !important;\n    }\n}\n\n.workerImg {\n    width: 200px;\n    height: 250px;\n    margin-left: auto;\n    margin-right: auto;\n    object-fit: cover;\n}\n\n.cardFooter {\n    display: flex;\n    gap: 20px;\n    background-color: #099268;\n    height: 150px;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    padding: 0 30px;\n\n    display: flex;\n    align-items: center;\n\n    &__date {\n        color: white;\n        margin-left: auto;\n        margin-right: auto;\n        font-size: 30px;\n    }\n\n    &__left {\n        width: 100px;\n        height: 100px;\n        // border: 1px solid white;\n\n        .qr {\n            width: 100px;\n            height: 100px;\n        }\n    }\n}\n\n.mainJob {\n    font-size: 45px;\n    color: white;\n}\n\n.cardFooterCode {\n    font-size: 30px;\n    color: white;\n}\n\n.studiing {\n    display: flex;\n    flex-direction: column;\n    margin-left: auto;\n    margin-right: auto;\n\n\n    &__block {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n\n        text-align: center;\n\n        h3 {\n            display: flex;\n            // justify-content: flex-start;\n            // justify-content: center;\n            // font-size: 45px;\n            font-size: 35px;\n            width: 80%;\n            line-height: 100%;\n\n            text-align: start;\n\n        }\n\n        span {\n            // font-size: 30px;\n            font-size: 25px;\n        }\n    }\n\n    .fontLarge {\n        font-size: 35px;\n    }\n\n    .fontSmall {\n        font-size: 25px;\n    }\n}\n\n\n\n\n\n\n@media print {\n    #sizer {\n        width: 100%;\n        height: auto;\n    }\n\n    @page {\n        size: 21cm 14.7cm;\n        // size: 23cm 14.7cm;\n        margin: 0;\n    }\n\n    //\n    html,\n    body {\n        width: 100% !important;\n        height: auto !important;\n        overflow: visible !important;\n    }\n\n    //\n\n\n    body * {\n        visibility: hidden;\n\n    }\n\n    .modal,\n    .modal * {\n        visibility: visible;\n\n    }\n\n    .modal {\n        position: absolute !important;\n\n\n        top: 0;\n        left: 0;\n        width: 100% !important;\n        height: auto !important;\n        overflow: visible !important;\n        background: white !important;\n        box-shadow: none !important;\n        backdrop-filter: none !important;\n        z-index: auto !important;\n\n        display: flex;\n        align-items: center;\n        overflow: hidden !important;\n    }\n\n    .content {\n        height: auto !important;\n        // height: 100% ;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        // width: 100%;\n        overflow: hidden !important;\n\n    }\n\n    .main {\n        overflow: hidden !important;\n    }\n\n    .left {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        // width: 500px;\n        // height: 750px;\n\n        border-radius: 5px;\n        text-align: center;\n\n        width: 10.5cm !important;\n        height: 14.7cm !important;\n\n\n    }\n\n    .cardMain {\n        display: flex;\n        flex-direction: column;\n        height: 600px;\n\n\n\n        h2 {\n            font-size: 40px;\n            //   font-size: clamp(30px, 5vw, 40px);\n        }\n\n        &__right {\n            // font-size: clamp(30px, 5vw, 40px);\n            font-size: 35px;\n        }\n    }\n\n    .workerImg {\n        width: 100px;\n        height: 150px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .cardFooter {\n        display: flex;\n        gap: 20px;\n        background-color: #099268;\n        height: 150px;\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n        padding: 0 30px;\n\n        display: flex;\n        align-items: center;\n\n        &__left {\n            display: block;\n            width: 50px;\n            height: 50px;\n            border: 1px solid white;\n        }\n    }\n\n    .mainJob {\n        font-size: 40px;\n        color: white;\n    }\n\n    .cardFooterCode {\n        font-size: 20px;\n        color: white;\n    }\n\n    .studiing {\n        display: flex;\n        flex-direction: column;\n        margin-left: auto;\n        margin-right: auto;\n\n\n        &__block {\n            display: flex;\n            align-items: center;\n            gap: 20px;\n\n            justify-content: flex-start;\n\n            h3 {\n                display: flex;\n                justify-content: flex-start;\n                // font-size: 30px;\n                // font-size: clamp(16px, 3vw, 30px);\n                // font-size: 20px;\n                width: 80%;\n\n                text-align: start;\n\n            }\n\n            span {\n                // font-size: 20px;\n                // font-size: clamp(16px, 2vw, 20px);\n            }\n        }\n    }\n\n    .fontLarge {\n        font-size: 25px !important;\n    }\n\n    .fontSmall {\n        font-size: 15px !important;\n    }\n\n    .qr {\n        width: 50px !important;\n        height: 50px !important;\n    }\n\n    .closeButton {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `WorkerModal_modal__zqO+H`,
	"content": `WorkerModal_content__ySTs2`,
	"main": `WorkerModal_main__aFm2G`,
	"footer": `WorkerModal_footer__AnfI-`,
	"left": `WorkerModal_left__W1t2X`,
	"cardMain": `WorkerModal_cardMain__o4Iaj`,
	"workerImg": `WorkerModal_workerImg__DRIbX`,
	"cardFooter": `WorkerModal_cardFooter__VwZ4v`,
	"cardFooter__date": `WorkerModal_cardFooter__date__xgtXs`,
	"cardFooter__left": `WorkerModal_cardFooter__left__gXeCf`,
	"qr": `WorkerModal_qr__g5hop`,
	"mainJob": `WorkerModal_mainJob__EDsqK`,
	"cardFooterCode": `WorkerModal_cardFooterCode__Y+gcd`,
	"studiing": `WorkerModal_studiing__8DA+j`,
	"studiing__block": `WorkerModal_studiing__block__AgOqj`,
	"fontLarge": `WorkerModal_fontLarge__uZOMS`,
	"fontSmall": `WorkerModal_fontSmall__sFnUm`,
	"sizer": `WorkerModal_sizer__PQ5We`,
	"cardMain__right": `WorkerModal_cardMain__right__Y77YY`,
	"closeButton": `WorkerModal_closeButton__cVvmy`
};
export default ___CSS_LOADER_EXPORT___;
